// extracted by mini-css-extract-plugin
export default {"holder":"compositions_holder__WYuK+","ingredientsRow":"compositions_ingredientsRow__x72gu"};